export default __webpack_public_path__ + "static/media/logoCard.fw.c385bbd5.png";